"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageCreationHelper = void 0;
var axios_1 = __importDefault(require("axios"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var FormToCreate_1 = require("Common/FormToCreate/FormToCreate");
var ProjectCreatedEvent_1 = require("@CommonFrontendBackend/Telemetry/ProjectCreatedEvent");
var CreatePageFlow_1 = __importDefault(require("@CommonFrontend/CreatePageFlow"));
var Types_2 = require("@CommonFrontendBackend/Projects/Types");
var types_1 = require("CreatePageFlow/types");
var createFormConfig = function (template) {
    var _a;
    var config = {};
    if ((_a = template.crmInfo) === null || _a === void 0 ? void 0 : _a.connected) {
        config.explainer =
            "If you have product line items in your quote, you will need to add these to the page as they are not yet supported by the form.";
    }
    return config;
};
var PageCreationHelper = (function () {
    function PageCreationHelper(apiBaseUrl, modal, environment, telemetry, serverTelemetry, $state, projectCreator, usingFeature, rootDataStore) {
        this.apiBaseUrl = apiBaseUrl;
        this.modal = modal;
        this.environment = environment;
        this.telemetry = telemetry;
        this.serverTelemetry = serverTelemetry;
        this.$state = $state;
        this.projectCreator = projectCreator;
        this.usingFeature = usingFeature;
        this.rootDataStore = rootDataStore;
    }
    PageCreationHelper.prototype.createPageFromTemplate = function (template, uiOrigin) {
        var _a, _b, _c;
        return __awaiter(this, void 0, Promise, function () {
            var useHistoryDataStore_1, createPageThenOpenEditor, response, tokenList;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (isPlatformSupportedTemplate(template)) {
                            useHistoryDataStore_1 = this.rootDataStore.userDataStore.useHistoryDataStore;
                            this.modal.showSimpleModal({
                                containerClassName: "create-page-flow-modal",
                                body: (0, CreatePageFlow_1.default)({
                                    flowOrigin: {
                                        source: types_1.CreatePageFlowSource.Qwilr,
                                        templateId: template.projectId,
                                        integrationName: (_a = template.crmInfo) === null || _a === void 0 ? void 0 : _a.integration,
                                    },
                                    apiBaseUrl: this.apiBaseUrl,
                                    closeButtonHandler: this.modal.closeAnyModals,
                                    accountId: this.rootDataStore.getAccountDataStore().id,
                                    telemetry: this.telemetry,
                                    serverTelemetry: this.serverTelemetry,
                                    prompts: {
                                        pageStateLive: {
                                            show: useHistoryDataStore_1.shouldShowPageStateChangeConfirmationModal(Types_2.ProjectStatus.Live),
                                            onHide: function () {
                                                useHistoryDataStore_1.hidePageStateChangeConfirmationModal(Types_2.ProjectStatus.Live);
                                            },
                                        },
                                    },
                                }),
                            });
                            return [2];
                        }
                        createPageThenOpenEditor = function (substitutions, isUsingFormToCreate) {
                            if (isUsingFormToCreate === void 0) { isUsingFormToCreate = true; }
                            return __awaiter(_this, void 0, Promise, function () {
                                var createdProjectId;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4, this.projectCreator.createProjectFromTemplate(template.projectId, template.name, {
                                                isAccountTemplate: template.isAccountTemplate,
                                                isAutoExpiryEnabled: template.isAutoExpiryEnabled,
                                                isSecurityEnabled: template.isSecurityEnabled,
                                                substitutions: substitutions,
                                                uiOrigin: uiOrigin,
                                                isUsingFormToCreate: isUsingFormToCreate,
                                            })];
                                        case 1:
                                            createdProjectId = _a.sent();
                                            this.$state.go("project", { id: createdProjectId });
                                            return [2];
                                    }
                                });
                            });
                        };
                        return [4, axios_1.default.get("".concat(this.apiBaseUrl, "/templates/").concat(template.projectId, "/tokens?dataType=").concat(Types_1.TokenDataType.String), {
                                withCredentials: true,
                            })];
                    case 1:
                        response = _d.sent();
                        tokenList = (_b = response.data) !== null && _b !== void 0 ? _b : [];
                        if (this.usingFeature(FeatureFlag_1.default.TemplateEssentialsCreator) && uiOrigin !== ProjectCreatedEvent_1.ProjectCreationUiOrigin.Onboarding) {
                            this.modal.showSimpleModal({
                                containerClassName: "narrow-create-page-app",
                                body: (0, CreatePageFlow_1.default)({
                                    flowOrigin: {
                                        source: types_1.CreatePageFlowSource.Qwilr,
                                        templateId: template.projectId,
                                        integrationName: (_c = template.crmInfo) === null || _c === void 0 ? void 0 : _c.integration,
                                    },
                                    apiBaseUrl: this.apiBaseUrl,
                                    closeButtonHandler: this.modal.closeAnyModals,
                                    accountId: this.rootDataStore.getAccountDataStore().id,
                                    telemetry: this.telemetry,
                                    serverTelemetry: this.serverTelemetry,
                                    tokenList: tokenList,
                                }),
                                isEscapable: false,
                            });
                            return [2];
                        }
                        else if ((tokenList === null || tokenList === void 0 ? void 0 : tokenList.length) > 0) {
                            (0, FormToCreate_1.createFormToCreateModal)(this.modal, this.environment, tokenList, this.telemetry, createPageThenOpenEditor, createFormConfig(template));
                            return [2];
                        }
                        return [4, createPageThenOpenEditor({}, false)];
                    case 2:
                        _d.sent();
                        return [2];
                }
            });
        });
    };
    return PageCreationHelper;
}());
exports.PageCreationHelper = PageCreationHelper;
var isPlatformSupportedTemplate = function (template) {
    return (template.crmInfo &&
        template.crmInfo.connected &&
        Types_1.PLATFORM_SUPPORTED_PROVIDER_TYPES.has(template.crmInfo.integration));
};
